import { render, staticRenderFns } from "./BreadcrumbAlt.vue?vue&type=template&id=d895af40&"
import script from "./BreadcrumbAlt.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbAlt.vue?vue&type=script&lang=js&"
import style0 from "./BreadcrumbAlt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports